import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { applySeoTags } from "./utils/seo";
applySeoTags();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-23" data-mp="21cag26t4o9gu" />);
}